import {
  PokemonType,
  SkillData,
  SkillType,
  SkillRangeType,
  SkillEvent_Vfx,
  SkillEvent_Global,
  TeamConditionEffect,
  SkillTeamCondition,
} from "types/battle-engine/battle";
import { parseSkillIdToName } from "../utils/parse-id-to-name";

// Global Healing Skills
export const [
  MORNING_SUN,
  AROMATHERAPY,
  HEALING_WISH,
  HEAL_ORDER,
  MOONLIGHT,
]: SkillData[] = [
  {
    id: "morning-sun",
    description:
      "Heals all allies. Increased healing if a Grass-type ally is present.",
    pokemon_type: PokemonType.FIRE,
    healing: 25,
    cooldown_ticks: 1000,
    team_conditions: [
      {
        condition: {
          type: "min_ally_type_count",
          pokemon_type: PokemonType.GRASS,
          value: 1,
        },
        effect: {
          stat: "healing_mult",
          value: 1.35,
        } as TeamConditionEffect,
      } as SkillTeamCondition,
    ],
  },
  {
    id: "aromatherapy",
    description:
      "Heals all allies. Increased healing if a Fairy-type ally is present.",
    pokemon_type: PokemonType.GRASS,
    healing: 9,
    cooldown_ticks: 125,
    team_conditions: [
      {
        condition: {
          type: "min_ally_type_count",
          pokemon_type: PokemonType.FAIRY,
          value: 1,
        },
        effect: {
          stat: "healing_mult",
          value: 1.35,
        } as TeamConditionEffect,
      } as SkillTeamCondition,
    ],
  },
  {
    id: "healing-wish",
    description: "Heals all allies.",
    pokemon_type: PokemonType.PSYCHIC,
    healing: 35,
    cooldown_ticks: 700,
  },
  {
    id: "heal-order",
    description: "Heals all allies.",
    pokemon_type: PokemonType.BUG,
    healing: 23,
    cooldown_ticks: 200,
  },
  {
    id: "moonlight",
    description:
      "Heals all allies. Increased healing if a Dark-type ally is present.",
    pokemon_type: PokemonType.FAIRY,
    healing: 20,
    cooldown_ticks: 200,
    team_conditions: [
      {
        condition: {
          type: "min_ally_type_count",
          pokemon_type: PokemonType.DARK,
          value: 1,
        },
        effect: {
          stat: "healing_mult",
          value: 1.35,
        } as TeamConditionEffect,
      } as SkillTeamCondition,
    ],
  },
].map((skill: any) => ({
  id: skill.id,
  event_checks:
    "event_checks" in skill
      ? (skill.event_checks as SkillData["event_checks"])
      : undefined,
  momentum:
    "momentum" in skill ? (skill.momentum as SkillData["momentum"]) : undefined,
  team_conditions:
    "team_conditions" in skill
      ? (skill.team_conditions as SkillData["team_conditions"])
      : undefined,
  starts_active:
    "starts_active" in skill ? (skill.starts_active as boolean) : undefined,
  name: parseSkillIdToName(skill.id),
  description: skill.description || "",
  power: skill.healing,
  pokemon_type: skill.pokemon_type,
  types: [SkillType.HEAL],
  cooldown_ticks: skill.cooldown_ticks,
  mana_cost: 10,
  range: {
    type: SkillRangeType.POINT_TARGET,
    value: 5,
  },
  on_hit: [],
  on_cast: [
    {
      __typename: "Vfx",
      duration_ticks: 15,
      target: {
        type: "self",
        id: 0,
      },
      status_effects: [],
      starting_tick: 0,
      sprite_path: "/assets/spells/vfx/self_sparkles_006__50.png",
      sprite_scale: 2,
      speed: 1.25,
      blocks_event_pipeline: false,
    } as SkillEvent_Vfx,
    {
      __typename: "Global",
      duration_ticks: 25,
      target: {
        type: "ally",
        id: 0,
      },
      healing: skill.healing,
      status_effects: [],
      starting_tick: 0,
      vfx: {
        sprite_path: "/assets/spells/self/healing-2-green.png",
        sprite_scale: 1.5,
        sprite_alpha: 1,
        speed: 0.2,
        anchor_to_target: true,
      },

      blocks_event_pipeline: true,
    } as SkillEvent_Global,
  ],
}));